export const ACTIONS = {
    EDIT: "Edit",
    CANCEL: "Cancel",
    SAVE: "Save",
};
